<template>
  <div v-click-outside="closeChat">
    <span class="material-icons" :helpy="helpy" :title="title" @click="toggleChat" role="button">psychology</span>

    <div class="chat-container d-flex flex-column align-items-end" :class="[{ open: isOpen }, position]">
      <div ref="history" class="chat-history d-flex flex-column w-100" :class="isOpen ? 'visible' : 'transparent'">
        <div
          v-for="(turn, index) in history"
          :key="index"
          class="d-flex flex-column"
          :class="{ 'mt-auto': index === 0 }"
        >
          <div v-if="turn.prompt" class="question ms-auto my-2 px-3 py-2">
            {{ turn.prompt }}
          </div>
          <div v-if="turn.choice" class="answer me-auto px-3 py-2" v-html="turn.choice"></div>
        </div>
        <template v-if="working">
          <div class="question ms-auto my-2 px-3 py-2">{{ temp }}</div>
          <div class="answer me-auto px-3 py-2">{{ $i18n.t('openai_typing') }}...</div>
        </template>
        <div ref="bottom" class="bottom" />
      </div>
      <div class="d-flex flex-column gap-2 w-100">
        <el-input
          :autosize="{ minRows: 1, maxRows: 6 }"
          type="textarea"
          :placeholder="$i18n.t('ask_something')"
          v-model="prompt"
        />
        <ai-button :loading="isGenerating" :title="$i18n.t('send')" :button-style="submitStyle" @click="submitPrompt" />
      </div>
    </div>
  </div>
</template>

<script>
import AiButton from '../ai/AiButton.vue'
import { get } from 'lodash'
import { AI_ASSISTANTS } from '../../consts'
import aiMixin from '../../utils/mixin-ai'

export default {
  name: 'OpenAiChat',
  components: { AiButton },
  props: {
    helpy: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  mixins: [aiMixin],
  data() {
    return {
      submitStyle: 'height: fit-content;align-self: flex-end;width: 150px;height: 40px',
      history: [],
      prompt: '',
      temp: '',
      isOpen: false,
      working: false,
      visible: false,
      isGenerating: false,
      threadId: null,
      prePrompt: 'A Prompt hozzád: ',
    }
  },
  computed: {
    position() {
      return this.$store.getters.sidebarPosition
    },
    turn() {
      return this.history.length - 1
    },
  },
  methods: {
    async submitPrompt() {
      if (!this.prompt?.length) return

      this.isGenerating = true
      const id = this.$uid(this.history.length)
      const prompt = get(this, 'prompt', '')
      this.prompt = ''
      const params = {
        assistant: AI_ASSISTANTS.DEFAULT_CHAT,
        message: `${this.prePrompt} ${prompt}`,
        threadId: this.threadId,
      }

      this.history.push({
        id,
        prompt,
        choice: '',
      })

      this.$client.streamEvent(
        '/api/Ais/chat',
        params,
        (data) => {
          this.stream().onMessage(data, id)
        },
        (data) => {
          this.stream().onEnd()
        },
        (error) => {
          this.stream().onError(error)
        },
        true
      )
    },
    stream() {
      const that = this
      return {
        onMessage(data, id) {
          const index = that.history.findIndex((item) => item.id === id)
          if (index !== -1) {
            that.$nextTick(() => {
              that.$set(that.history, index, {
                ...that.history[index],
                choice: data.replace(/【(.*?)】/g, ''),
              })
            })
          }
        },
        onEnd() {
          that.isGenerating = false
          that.scrollHistory()
        },
        onError(error) {
          that.isGenerating = false
          that.$notify({
            title: error,
            type: 'error',
          })
        },
      }
    },
    toggleChat() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.setThreadId()
        this.scrollHistory()
      }
    },
    scrollHistory() {
      this.$nextTick(() => {
        const history = this.$refs['history']
        const bottom = this.$refs['bottom']
        if (bottom) {
          history.style.scrollBehavior = 'smooth'
          bottom.scrollIntoView()
        }
      })
    },
    closeChat() {
      this.isOpen = false
    },
    async setThreadId() {
      if (!this.threadId) {
        this.threadId = await this.createThread()
      }
    },
  },
  mounted() {
    this.history.push({
      choice: this.$i18n.t('how_can_i_be_of_assistance?'),
      prompt: '',
    })
  },
}
</script>

<style lang="scss" scoped>
.visible {
  opacity: 1;
  transition: 0.4s all cubic-bezier(1, -0.4, 1, 0.3);
}
.transparent {
  opacity: 0;
  transition: 0.3s all step-start;
}
.material-icons {
  color: #eae7f2;
}
.chat-container,
.chat-container * {
  z-index: -1;
}
.chat-container {
  width: 400px;
  height: 100vh;
  position: absolute;
  top: 0;
  transition: 0.3s all ease-in;
  background: $sidebar-color;
  padding: 3rem 1rem 1rem;
  &.left {
    left: -500px;
    &.open {
      left: 60px;
    }
  }
  &.right {
    right: -500px;
    &.open {
      right: 60px;
    }
  }
  .chat-history {
    margin: auto 0 1rem;
    line-height: 1.2;
    height: 100%;
    overflow: auto;
    .question {
      max-width: 90%;
      border-radius: 15px;
      background-color: $white;
      color: $color-primary;
    }
    .answer {
      max-width: 90%;
      border-radius: 15px;
      background-color: $color-primary;
      color: $white;
    }
    .bottom {
      width: 100%;
      height: 1px;
    }
  }
}
</style>
